import { requestJson } from "../api/apiClient";

export async function fetchVehicleSources(filters = {}) {
  const params = new URLSearchParams();
  if (filters.sourceType) params.set("source_type", filters.sourceType);
  if (filters.needsReview === true) {
    params.set("needs_review", "true");
  } else if (filters.sourceStatus) {
    params.set("source_status", filters.sourceStatus);
  }
  if (filters.isActive !== undefined && filters.isActive !== "") {
    params.set("is_active", String(filters.isActive));
  }
  if (filters.allowedToIngest !== undefined && filters.allowedToIngest !== "") {
    params.set("allowed_to_ingest", String(filters.allowedToIngest));
  }
  if (filters.robotsReviewStatus) params.set("robots_review_status", filters.robotsReviewStatus);
  if (filters.termsReviewStatus) params.set("terms_review_status", filters.termsReviewStatus);
  if (filters.accessReviewStatus) params.set("access_review_status", filters.accessReviewStatus);
  if (filters.city) params.set("city", filters.city);
  if (filters.department) params.set("department", filters.department);
  if (filters.search) params.set("search", filters.search);
  if (filters.sort) params.set("sort", filters.sort);
  if (filters.sortDir) params.set("sort_dir", filters.sortDir);

  const query = params.toString();
  const data = await requestJson(`/api/admin/vehicle-sources${query ? `?${query}` : ""}`);
  return {
    sources: data.sources || [],
    summary: data.summary || null,
  };
}

export async function fetchVehicleSourceComplianceSummary() {
  const data = await requestJson("/api/admin/vehicle-sources/compliance-summary");
  return data.summary;
}

export async function fetchVehicleSourceById(id) {
  const data = await requestJson(`/api/admin/vehicle-sources/${encodeURIComponent(id)}`);
  return data.source;
}

export async function createVehicleSource(payload) {
  const data = await requestJson("/api/admin/vehicle-sources", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return data.source;
}

export async function updateVehicleSource(id, payload) {
  const data = await requestJson(`/api/admin/vehicle-sources/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  return { source: data.source, ingestReadiness: data.ingestReadiness };
}

export async function patchVehicleSourceReview(id, payload) {
  const data = await requestJson(
    `/api/admin/vehicle-sources/${encodeURIComponent(id)}/review`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    }
  );
  return { source: data.source, ingestReadiness: data.ingestReadiness };
}

export async function applyVehicleSourceReviewPreset(id, preset, options = {}) {
  return patchVehicleSourceReview(id, {
    preset,
    blockedReason: options.blockedReason,
  });
}

export async function setVehicleSourceActive(id, isActive) {
  return updateVehicleSource(id, { isActive });
}
